import React from "react";
import { Button } from "react-bootstrap";

function NewLogin(props) {

  return (
    <>
      <div className="ligin-form loginForm">
        <div className="form-wrapper">
          <div className="w-100">
            <span>{process.env.REACT_APP_LOGINTEXT}</span>
            <Button
              data-test="normalLogin"
              title="Log On"
              id='normalLogin'
              variant="outlined"
              color="primary"
              className="btn  btn-primary w-100 login-btn mb-3 mt-3"
              onClick={() => props.onNormalLoginSelect?.()}
            >
              {process.env.REACT_APP_LOGIN}
            </Button>
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
}

export default NewLogin;
